import ReactMultiQueryBuilder from './ReactMultiQueryBuilder';

export default ReactMultiQueryBuilder;